import { BusinessType, CountryList } from "../../types";

type ValueOrUndefined<T> = T | undefined;

export const determineOwnerApplicable = (
  registeredCountry: ValueOrUndefined<CountryList>
): boolean => {
  const approvedCountries = [
    "United States",
    "Canada",
    "United Kingdom",
    "Australia",
    "New Zealand",
  ];
  return approvedCountries.includes(registeredCountry ? registeredCountry : "");
};

export const determineNonOwnerApplicable = (
  registeredCountry: ValueOrUndefined<CountryList>,
  businessType: ValueOrUndefined<BusinessType>
): boolean => {
  if (
    registeredCountry === "United States" &&
    businessType !== "Sole Proprietorship"
  ) {
    return true;
  }
  if (
    // this is just the rest of the countries so this could just be an else statement but in current app they do it explicitly
    registeredCountry === "Australia" ||
    registeredCountry === "New Zealand" ||
    registeredCountry === "United Kingdom" ||
    registeredCountry === "Canada"
  ) {
    return true;
  }
  return false;
};
